/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {
  $,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
  Helper,
} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import CheckboxWithOptions from '@/components/CheckboxWithOptions.vue'
import {ITipoClienteResourcesHolder} from '@/interfaces/resource/ITipoClienteResourcesHolder'
import {TipoClienteCollection} from '@/model/collection/TipoClienteCollection'
import InputTipoCliente from '@/components/InputTipoCliente.vue'
import InputWebhook from '@/components/InputWebhook.vue'
import CheckboxWithPassword from '@/components/CheckboxWithPassword.vue'

export class InputResponsavelFlagsWithOptions extends Schema
  implements ITipoClienteResourcesHolder {
  collectionTipoCliente = new TipoClienteCollection().noPagination()
  isSenhaDevolverNotaMatch: boolean | null = null
  isSenhaDevolverNotaFinalizadaParaNaoIniciadaMatch: boolean | null = null
  isSenhaExcluirNotasFinalizadasMatch: boolean | null = null

  readonly name = 'InputResponsavel'
  readonly fieldSet: FieldSet<Responsavel> = {
    tipoCliente: (schema): FieldComponent => ({
      is: InputTipoCliente,
      bind: {
        resourceHolder: this,
        model: schema.model.tipoCliente,
        optionValue: schema.model.parceiroNome,
        class: 'col-span-2',
      },
      on: {
        updateOption: (val: string) => (schema.model.parceiroNome = val),
      },
    }),
    usaIntegracao: (schema): FieldComponent => ({
      is: CheckboxWithOptions,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.usaIntegracao,
        optionValue: schema.model.integracaoTMS,
        optionType: 'text',
        optionLabel: $.t('schema.InputResponsavel.integracaoTMS'),
        inputClass: 'uppercase',
      },
      on: {
        updateOption: (val: string) => (schema.model.integracaoTMS = val),
      },
    }),
    clientePossuiTorreDeControle: (schema): FieldComponent => ({
      is: CheckboxWithOptions,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.clientePossuiTorreDeControle,
        optionValue: schema.model.nomeResponsavelTorreDeControle,
        optionType: 'text',
        optionLabel: $.t(
          'schema.InputResponsavel.nomeResponsavelTorreDeControle'
        ),
        inputClass: 'uppercase',
      },
      on: {
        updateOption: (val: string) =>
          (schema.model.nomeResponsavelTorreDeControle = val),
      },
    }),
    habilitarBI: (schema): FieldComponent => ({
      is: CheckboxWithOptions,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.habilitarBI,
        optionValue: schema.model.linkBI,
        optionType: 'text',
        optionLabel: $.t('schema.InputResponsavel.linkBI'),
      },
      on: {
        updateOption: (val: string) => (schema.model.linkBI = val),
      },
    }),
    permitirCheckinAutomatico: (schema): FieldComponent => ({
      is: CheckboxWithOptions,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.permitirCheckinAutomatico,
        optionValue: schema.model.raioCheckinAutomatico,
        optionType: 'number',
        optionLabel: $.t('schema.InputResponsavel.raioCheckinAutomatico'),
      },
      on: {
        updateOption: (val: number) =>
          (schema.model.raioCheckinAutomatico = val),
      },
    }),
    permitirDevolverNotaFinalizadaParaNaoIniciada: (
      schema
    ): FieldComponent => ({
      is: CheckboxWithPassword,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.permitirDevolverNotaFinalizadaParaNaoIniciada,
        repeatPasswordLabel: $.t(
          'schema.InputResponsavel.repeatSenhaDevolverNotaFinalizadaParaNaoIniciada'
        ),
        passwordValue: schema.model.senhaDevolverNotaFinalizadaParaNaoIniciada,
        passwordLabel: $.t(
          'schema.InputResponsavel.senhaDevolverNotaFinalizadaParaNaoIniciada'
        ),
        validation: 'min:6',
        class: 'col-span-2',
      },
      on: {
        updatePassword: (val: string) =>
          (schema.model.senhaDevolverNotaFinalizadaParaNaoIniciada = val),
        inputPasswordMatch: (val: boolean) =>
          (this.isSenhaDevolverNotaFinalizadaParaNaoIniciadaMatch = val),
      },
    }),
    permitirDevolverNota: (schema): FieldComponent => ({
      is: CheckboxWithPassword,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.permitirDevolverNota,
        repeatPasswordLabel: $.t(
          'schema.InputResponsavel.repeatSenhaDevolverNota'
        ),
        passwordValue: schema.model.senhaDevolverNota,
        passwordLabel: $.t('schema.InputResponsavel.senhaDevolverNota'),
        validation: 'min:6',
        class: 'col-span-2',
      },
      on: {
        updatePassword: (val: string) => (schema.model.senhaDevolverNota = val),
        inputPasswordMatch: (val: boolean) =>
          (this.isSenhaDevolverNotaMatch = val),
      },
    }),
    permitirExcluirNotasFinalizadas: (schema): FieldComponent => ({
      is: CheckboxWithPassword,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.permitirExcluirNotasFinalizadas,
        repeatPasswordLabel: $.t(
          'schema.InputResponsavel.repeatExcluirNotasFinalizadas'
        ),
        passwordValue: schema.model.senhaExcluirNotasFinalizadas,
        passwordLabel: $.t(
          'schema.InputResponsavel.senhaExcluirNotasFinalizadas'
        ),
        validation: 'min:6',
        class: 'col-span-2',
      },
      on: {
        updatePassword: (val: string) =>
          (schema.model.senhaExcluirNotasFinalizadas = val),
        inputPasswordMatch: (val: boolean) =>
          (this.isSenhaExcluirNotasFinalizadasMatch = val),
      },
    }),
    webhookOcorrenciaM1: (schema): FieldComponent => ({
      is: InputWebhook,
      bind: {
        model: schema.model,
        class: 'col-span-2',
      },
    }),
  }
}
